// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1-tmV","title":"Images90_title__WbpcY","images":"Images90_images__2l2e5"};